import { css } from 'styled-components';
import { colors } from '@izettle/otto';
import { focusOutlineMixin } from '../../../mixins.js';

const IconButtonColorCss = {
  primary: css`
    color: ${colors.action.inline.text.default};

    &:hover {
      border-color: ${colors.action.inline.border.hover};
      background-color: ${colors.action.secondary.background.hover};
      color: ${colors.action.primary.background.hover};
    }
    &:focus {
      ${focusOutlineMixin}
    }
    &:active {
      border-color: ${colors.action.inline.border.selected};
      background-color: ${colors.action.secondary.background.selected};
      color: ${colors.action.inline.text.selected};
    }
    &:disabled {
      color: ${colors.action.inline.text.disabled};
    }
  `,
  minor: css`
    color: ${colors.action.minor.text.default};

    &:hover {
      border-color: ${colors.action.minor.border.hover};
      background-color: ${colors.action.minor.background.hover};
      color: ${colors.action.minor.text.hover};
    }
    &:focus {
      ${focusOutlineMixin}
    }
    &:active {
      border-color: ${colors.action.minor.border.selected};
      background-color: ${colors.action.minor.background.selected};
      color: ${colors.action.minor.text.selected};
    }
    &:disabled {
      color: ${colors.action.minor.text.disabled};
    }
  `,
  destructive: css`
    color: ${colors.action.destructive.text.default};

    &:hover {
      border-color: ${colors.action.destructive.border.hover};
      background-color: ${colors.action.destructive.background.hover};
      color: ${colors.action.destructive.text.hover};
    }
    &:focus {
      ${focusOutlineMixin}
    }
    &:active {
      border-color: ${colors.action.destructive.border.selected};
      background-color: ${colors.action.destructive.background.selected};
      color: ${colors.action.destructive.text.selected};
    }
    &:disabled {
      color: ${colors.action.destructive.text.disabled};
    }
  `
};

export { IconButtonColorCss };
//# sourceMappingURL=variants.js.map
